import { motion } from 'framer-motion'

import Image from 'next/image'

import { PageHeader } from '../fuselage/layout/esg/page-header/page-header'
import { StickySidebar, StickySidebarSection } from '../fuselage/layout/esg/sticky-sidebar/sticky-sidebar'
import { Sidebar } from '../fuselage/layout/esg/sidebar/sidebar'
import { BenchLogo } from '../fuselage/components/bench-logo/bench-logo'
import { Box } from '../fuselage/layout/esg/box/box'


export default function EsgPage () {

    return (
        <>

            <PageHeader />


            {/* operations */}

            <StickySidebar backgroundColor={`var(--primary)`}>
                <aside className='bg-primary py-md pl-lg pr-md'>
                    <p className='fs-2 fw-500 c-white'>Operations</p>
                </aside>

                <main className='formatted'>

                    <StickySidebarSection decal='bg-white py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-waste-reduction.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-primary'>Waste Reduction</p>
                            <ul className='square'>
                                <li>We will strive to minimize waste by implementing a “Reduce, Reuse, and Recycle” policy throughout our event planning process.</li>
                                <li>We will not use single-use plastic and instead opt for reusable or compostable alternatives for all event materials, including but not limited to, décor, signage, and promotional materials.</li>
                                <li>We will prioritize collaborating with suppliers who provide sustainable alternatives to traditional materials, such as biodegradable or compostable options.</li>
                                <li>Additionally, we will rent all equipment instead of purchasing it to reduce waste and avoid unnecessary consumption of resources.</li>
                                <li>To further reduce our environmental impact, we will continue using a digital app instead of printed materials for our events. This will eliminate the need for paper-based programs, schedules, and other printed materials, reducing waste and carbon emissions associated with their production and transportation.</li>
                                <li>We will also encourage our sponsors, partners, and delegates to use the event app in place of traditional printed materials. By promoting the use of digital technology, we can reduce waste and carbon emissions while also enhancing the attendee experience.</li>
                                <li>We will also encourage attendees to reduce waste by providing recycling and compost bins throughout the event venue and educating them on the importance of waste reduction.</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                    <StickySidebarSection decal='bg-primary-wash py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-transport.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-primary'>Sustainable Transportation</p>
                            <ul className='square'>
                                <li>We will encourage the use of sustainable transportation options such as public transportation, bike-sharing schemes, or carpooling for attendees and staff.</li>
                                <li>We will also choose venues that are accessible by public transportation</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                    <StickySidebarSection decal='bg-white py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-co2.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-primary'>ESG at our conference venue - Prague Marriott Hotel</p>
                            <ul className='square'>
                                <li>On a global level, last year Marriott International joined the Race to Zero initiative, which brings together companies as well as various institutions and local authorities with the aim of achieving zero greenhouse gas emissions across the supply chain by 2050 at the latest.</li>
                                <li>Installed soap and shampoo dispensers in all ensuite bathrooms, replacing the previous disposable plastic bottles. This is part of a global initiative by Marriott International, meaning the change has taken place in all hotels under our brand. We expect to save up to 500 million single-use plastic bottles from landfill each year as a result.</li>
                                <li>Digitization of services - all of the reservation and check- in processes are being done electronically. Guests can also choose a mobile room key, so they no longer need to take a plastic card. We have also introduced QR codes for various activities throughout the hotel, which are proving to be very popular with guests. In addition, in the autumn, we will be making another important change: we will renew our fleet of vehicles so that passenger transport for guests will exclusively use hybrid cars from the second half of this year.</li>
                                <li>Zero-Waste Concept Restaurant (The Artisan): A team of local chefs processes seasonal ingredients and keeps an inventory of them for the months ahead. This avoids unnecessary waste; simply put, whatever does not end up on the plate - peelings, pits, pulp, seeds and other scraps - is reused in other ways through the fermentation process. The unmistakeable flavours created by fermentation give guests at The Artisan the opportunity to taste truly original dishes that they will not find elsewhere.</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                    <StickySidebarSection decal='bg-primary-wash py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-energy.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-primary'>Sustainable Energy</p>
                            <ul className='square'>
                                <li>We will prioritize the use of renewable energy sources, such as solar or wind power, in our events wherever possible.</li>
                                <li>We will also minimize energy consumption by using energy-efficient lighting and HVAC systems.</li>
                                <li>We recognize the environmental impact of storing data on the cloud and will prioritize reducing our data footprint by regularly reviewing and removing any unnecessary or outdated data.</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                </main>
            </StickySidebar>


            {/* programme */}

            <StickySidebar backgroundColor={`var(--secondary)`}>
                <aside className='py-md pl-lg pr-md'>
                    <p className='fs-2 fw-500 c-white'>Programme</p>
                </aside>

                <main className='bg-default formatted bg-white p-md'>
                    <div className="columns-2 gap-md fw-500 maxw-60">
                        <div>
                            <ul className="square">
                                <li>In addition to prioritizing sustainable practices in our event operations and supporting local charity initiatives, we are committed to incorporating ESG topics into our program sessions. By highlighting the importance of environmental stewardship, social responsibility, and sound governance practices, we aim to educate and inspire our attendees to make a positive impact on society and the environment.</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="square">
                                <li>Incorporating ESG goals into their strategy is increasingly necessary for any business looking to stay ahead of the competition and create meaningful change . That&apos;s why we have made a bold decision to have 35-40% of our programme topics around ESG and sustainable development with the aim to educate the industry on possible solutions regarding future sustainable development</li>
                            </ul>
                        </div>
                    </div>
                </main>
            </StickySidebar>


            {/* operations */}

            <StickySidebar backgroundColor={`var(--accent)`}>
                <aside className='py-md pl-lg pr-md'>
                    <p className='fs-2 fw-500 c-white lh-1'>Social Sustainability</p>
                </aside>

                <main className='bg-default formatted'>

                    <StickySidebarSection decal='bg-accent-wash py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-community.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-accent'>Community Engagement:</p>
                            <ul className='square'>
                                <li>We will prioritize working with local suppliers, vendors, and contractors to support the local community and reduce our carbon footprint.</li>
                                <li>We will also engage with local organizations to create events that are relevant to the community&apos;s needs.</li>
                                <li>We will not only prioritize sustainable practices in our event operations, but we will also support local charity initiatives to reduce poverty and hunger in the communities where we operate. By partnering with local organizations and investing in programs that address these critical social issues, we can make a positive impact on both people and the planet.</li>
                                <li>As part of our commitment to promoting sustainability and supporting future industry professionals, we will be providing opportunities for students to work with us at our events. By offering internships and other work experiences, we can help to develop the skills and knowledge of the next generation of event professionals, while also providing them with the opportunity to meet industry peers and build connections. We believe that investing in the future of the event industry is essential to creating a sustainable future for all.</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                    <StickySidebarSection decal='bg-white py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-safety.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-accent'>Health and Safety:</p>
                            <ul className='square'>
                                <li>We will prioritize the health and safety of our attendees and staff by implementing strict health and safety protocols in accordance with local laws and regulations.</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                    <StickySidebarSection decal='bg-accent-wash py-md pl-md pr-lg'>
                        <aside>
                            <Box src={`/assets/theme/esg/box-diversity.png`} />
                        </aside>
                        <main>
                            <p className='fs-3 fw-400 c-accent'>Diversity and Inclusion:</p>
                            <ul className='square'>
                                <li>We will strive to create events that are inclusive of all individuals regardless of their race, gender, religion, or sexual orientation</li>
                            </ul>
                        </main>
                    </StickySidebarSection>

                </main>
            </StickySidebar>


            {/* commitment */}

            <Sidebar>
                <aside className={`bg-secondary p-md`}>
                    <BenchLogo />
                    <p className='fs-2 fw-300 lh-1 caps mt-xs'>Sustainability Commitment</p>
                </aside>
                <main className={`bg-primary formatted p-md`}>
                    <div className="maxw-60">
                        <p className='fs-6 fw-500 pb-sm'>At The Bench, we recognize the importance of sustainability in our industry and its impact on the environment, economy, and society. Therefore, we have developed a Sustainability Policy to outline our commitment to operating our events in a socially and environmentally responsible manner.</p>
                        <p>On November 5, 2021 The Bench became a Signatory of the Net Zero Carbon Events Pledge as an Operator.</p>
                        <p>The Net Zero Carbon Events initiative is the events industry&apos;s global campaign to achieve net zero carbon by 2050 at the latest. It has been launched in August 2021. Today, there are over 400 supporting organizations from 55 countries, including 275 event operators.</p>
                        <p>
                            <a href="https://netzerocarbonevents.org/" target="_blank" rel="noreferrer">https://netzerocarbonevents.org/</a>
                            <br/>Pledge: <a href="https://netzerocarbonevents.org/the-pledge/" target="_blank" rel="noreferrer">https://netzerocarbonevents.org/the-pledge/</a>
                        </p>

                    </div>
                </main>
            </Sidebar>
            


            <section className='block'>
                <div className="container">
                    <p className='fs-2 fw-400 c-primary'>Continuous Improvement:</p>
                </div>

                <div className="container columns-3 gap-md">
                    <div className='formatted'>
                        <p className='fs-xl fw-200 c-secondary bb-1 bc-secondary'>1</p>
                        <p className='fs-4 fw-600 c-primary'>Measurement and Reporting:</p>
                        <p>We will measure our sustainability performance and report it publicly to stakeholders, including attendees, clients, and partners on a yearly basis and per each event separately. In 2023 we will continuously measure our carbon footprint and write a detailed step-by-step plan of how and how much we will reduce our footprint by 2030 and 2050. In addition, we will ask all our delegates for information about where are they traveling from and to, by what type of transport, how long are they staying at the destination and in what kind of accommodation. With that, we will be able to measure not only the event&apos;s carbon footprint but also our delegates&apos;.</p>
                    </div>
                    <div className='formatted'>
                        <p className='fs-xl fw-200 c-secondary bb-1 bc-secondary'>2</p>
                        <p className='fs-4 fw-600 c-primary'>Innovation: </p>
                        <p>We will continually research and adopt new technologies and practices that will enable us to operate in a more sustainable manner.</p>
                    </div>
                    <div className='formatted'>
                        <p className='fs-xl fw-200 c-secondary bb-1 bc-secondary'>3</p>
                        <p className='fs-4 fw-600 c-primary'>Training and Development: </p>
                        <p>We will provide ongoing training and development opportunities for our staff to increase their knowledge of sustainability and their ability to implement sustainable practices in our events.</p>
                    </div>
                </div>
            </section>



            <Sidebar>
                <aside className={`bg-secondary`}>
                </aside>
                <main className={`bg-primary formatted p-md`}>
                    <div className="maxw-60">
                        <p>At The Bench, we are committed to sustainability and recognize the importance of operating in a socially and environmentally responsible manner. We will continue to review and improve our sustainability practices to ensure that we are making a positive impact on the environment, economy, and society as well as implementing tools which will help us measure precisely our carbon footprint.</p>
                        <p>We believe that by working together towards a more sustainable future, we can create a positive impact on both our business and the planet.</p>
                    </div>
                </main>
            </Sidebar>
            

        </>
    )
}